/**
 * Filet de sécurité global.
 *
 * Sans lui, une seule erreur de rendu (par exemple un objet passé là où React
 * attend du texte) vide entièrement la page : l'utilisateur voit un écran blanc
 * et n'a aucun moyen de repartir. C'est exactement ce qui pouvait arriver sur le
 * parcours d'inscription.
 *
 * Les causes connues ont été corrigées ; ce composant garantit que la PROCHAINE,
 * inconnue, dégrade l'expérience au lieu de la détruire.
 */
import React from "react";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // Pas de service externe ici : la console suffit et n'ajoute aucune
    // dépendance ni fuite de données.
    console.error("[ErrorBoundary]", error, info?.componentStack);
  }

  handleReload = () => {
    this.setState({ hasError: false });
    window.location.assign("/");
  };

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
        <div className="max-w-md rounded-lg border border-gray-200 bg-white p-6 text-center shadow-sm">
          <h1 className="text-lg font-semibold text-gray-900">
            Cette page n'a pas pu s'afficher
          </h1>
          <p className="mt-2 text-sm text-gray-600">
            Un incident technique est survenu de notre côté. Vos fiches
            enregistrées ne sont pas affectées.
          </p>
          <button
            onClick={this.handleReload}
            className="mt-4 rounded-md bg-blue-600 px-4 py-2 text-sm font-medium text-white hover:bg-blue-700"
          >
            Revenir à l'accueil
          </button>
          <p className="mt-3 text-xs text-gray-500">
            Si cela se reproduit, écrivez-nous à contact@wana-family.fr.
          </p>
        </div>
      </div>
    );
  }
}

export default ErrorBoundary;
